<div class="users-list-wrapper">

  @if (isLoading) {
    <div class="loading-container">
      <qai-loading [size]="loadingSize" />
    </div>
  }

  @if (!isLoading) {
    <div class="toolbar">
      <div class="search-input-wrapper">
        <qai-field [label]="''">
          <qai-icon kind="search-lg" qaiSlot="startIcon" />
          <input
            qai-input
            size="lg"
            type="text"
            [placeholder]="i18nKeys.searchPlaceholder | transloco"
            [value]="searchTerm()"
            (input)="onSearchChange($event)"
          />
        </qai-field>
      </div>
    </div>
  }

  @if (hasNoResults || hasNoUsers) {
    <div class="empty-container">
      <p>{{ i18nKeys.noUsersFound | transloco }}</p>
    </div>
  }

  @if (!isLoading && tableData().length > 0) {
    <qai-table
      [headers]="headers"
      [data]="tableData()"
      [striped]="false"
      [initialSortColumn]="initialSortColumn"
      [initialSortDirection]="initialSortDirection"
      [previousLabel]="i18nKeys.previousLabel | transloco"
      [nextLabel]="i18nKeys.nextLabel | transloco"
      (rowClick)="onRowClick($event)"
    />
  }

</div>
